module.exports = "<div *ngIf=\"!!message\">\n  <div class=\"disabled-background\" [class.disabled-background-try]=\"showTryView\"></div>\n  <div id=\"disabled-message\">\n    <span>{{message}}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/disabled-dashboard/disabled-dashboard.component.html
// module id = ./src/app/disabled-dashboard/disabled-dashboard.component.html
// module chunks = main